import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class FunnelService {
  constructor(private http: HttpClient) {}

  /**
   * Получение gtm метки по отпечатку
   */
  getGtmTagByFingerprint(
    pageId: any,
    fingerprint: string,
    requestOptions = { withCredentials: true }
  ): Observable<any> {
    return this.http.get(
      `${environment.gtmPath}/page/${pageId}/fingerprint/${fingerprint}`,
      requestOptions
    );
  }
}
